import React from "react";
import PropTypes from "prop-types";
import CustomSwitch from "../CustomInput/CustomSwitch";
import FormField from "./FormField";

function FormSwitch(props) {
  return (
    <FormField
      defaultValue={false}
      {...props}
      Field={CustomSwitch}
      fieldProps={(props) => ({ checked: props.value ?? false, style: null, value: undefined })}
    />
  );
}

FormSwitch.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  label: PropTypes.oneOf([PropTypes.element, PropTypes.string]), // FormField props
};

export default FormSwitch;
